import { useEffect, useRef } from 'react';
import { consumeConfirmLeaveBypass } from './confirmLeavePageBypass';

const DEFAULT_MESSAGE =
	'Are you sure you want to leave this page? Your progress may be lost.';

export function useConfirmBeforeUnload(enabled: boolean, message?: string) {
	const messageRef = useRef(message);

	useEffect(() => {
		messageRef.current = message;
	}, [message]);

	useEffect(() => {
		if (!enabled) return;

		const handler = (event: BeforeUnloadEvent) => {
			if (consumeConfirmLeaveBypass()) {
				return;
			}

			const promptMessage = messageRef.current ?? DEFAULT_MESSAGE;

			event.preventDefault();
			// Most browsers show a generic message; setting returnValue is still required.
			event.returnValue = promptMessage;
			return promptMessage;
		};

		window.addEventListener('beforeunload', handler);
		return () => window.removeEventListener('beforeunload', handler);
	}, [enabled]);
}
